import { TableStructure } from "../components/TableStructure";
const Monsoon_Book = () => (
  <TableStructure
    heading={"Monsoon Book"}
    list={[
      {
        fileStoreId: "75f69799-b06d-492c-84ad-07b2895fe9ba",
        label: "Monsoon Book",
      },
    ]}
    columnNo={1}
  />
);

export default Monsoon_Book;
